import { SensorModelConfiguration } from '../types';

/**
 * Configuration du modèle MILESIGHT WS301
 * Capteur de détection d'ouverture de porte (magnet status)
 */
export const MILESIGHT_WS301: SensorModelConfiguration = {
  brand: 'MILESIGHT',
  model: 'WS301',
  metrics: {
    magnet_status: {
      type: 'string',
      unit: '',
      icon: 'SensorDoorIcon',
      color: 'info.main',
      labelRef: 'status'
    }
  }
};
